import React, { useState } from "react";
import { Image as ImageIcon } from "lucide-react";

import "./AlbumPhotoGrid.css";

export default function AlbumPhotoCard({
  image,
  index = 0,
  onClick,
  disabled = false,
  className = "",
}) {
  const [loadedUrl, setLoadedUrl] = useState(null);
  const [failedUrl, setFailedUrl] = useState(null);

  const imageUrl =
    image?.thumbnailUrl || image?.signedUrl || image?.imageUrl || null;

  const title = image?.title || `Photo ${index + 1}`;

  const isLoaded = Boolean(imageUrl && loadedUrl === imageUrl);
  const hasError = Boolean(imageUrl && failedUrl === imageUrl);

  const canOpen =
    !disabled && Boolean(imageUrl) && !hasError && Boolean(onClick);

  return (
    <button
      type="button"
      className={[
        "album-photo-card",
        disabled && "album-photo-card--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={() => canOpen && onClick(index)}
      disabled={!canOpen}
      aria-label={`View ${title}`}
    >
      <div className="album-photo-card__thumbnail">
        {imageUrl && !isLoaded && !hasError && (
          <span className="album-photo-card__loading" aria-hidden="true" />
        )}

        {(!imageUrl || hasError) && (
          <span className="album-photo-card__placeholder">
            <ImageIcon size={28} strokeWidth={1.8} aria-hidden="true" />
          </span>
        )}

        {imageUrl && !hasError && (
          <img
            key={imageUrl}
            src={imageUrl}
            alt=""
            className={[
              "album-photo-card__image",
              isLoaded && "album-photo-card__image--loaded",
            ]
              .filter(Boolean)
              .join(" ")}
            draggable={false}
            loading={index < 4 ? "eager" : "lazy"}
            decoding="async"
            fetchPriority={index === 0 ? "high" : "low"}
            onLoad={() => setLoadedUrl(imageUrl)}
            onError={() => setFailedUrl(imageUrl)}
          />
        )}
      </div>
    </button>
  );
}
